module.exports = __webpack_public_path__ + "static/media/wheelchair.b879a78d.svg";